import styled from 'styled-components';

const StyledSpan = styled.span`
	font-family: 'GT Walsheim Pro';
	color: white;
`;

const StyledActionButton = styled.button`
	display: flex;
	gap: 15px;
	padding: 15px;
	margin: 0;
	border-width: 0;
	border-radius: 10px;
	background-color: black;
	cursor: pointer;
	user-select: none;
	transition: background-color 0.25s ease;

	> img {
		transition: filter 0.25s ease;
	}

	> span {
		width: 100%;
		font-size: 18px;
		transition: color 0.25s ease;
	}

	* {
		pointer-events: none;
	}

	&:hover {
		background-color: white;

		> img {
			filter: invert(100%);
		}

		> span {
			color: black;
		}
	}

	&:focus {
		outline: none;
	}
`;

export { StyledSpan, StyledActionButton };
